import React from 'react';
import { Row, Column } from '@upgrade/react-components';
import { Section } from '../styles';
import { StyledIframe, Container } from './styles';
import { getVideoId } from '../../../utils/youtube';
import { Heading, Text } from '../TypographyPublicSite';

const Video = ({ videoUrl, ...props }) => {
  const { title, description, contentComponent, content, height, width } = props;
  const ContentComponent = contentComponent;

  const videoId = getVideoId(videoUrl);
  const isVimeoVideo = videoUrl?.includes('vimeo');

  const videoIframe = (
    <StyledIframe
      title={title}
      src={isVimeoVideo ? videoUrl : `https://www.youtube.com/embed/${videoId}`}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
      $width={width}
      $height={height}
    />
  );

  return (
    <Section padding="xs" borderless>
      <Row xsHorizontalAlign="center">
        {isVimeoVideo ? (
          <Column xs={12}>{videoIframe}</Column>
        ) : (
          <Column xs={12} sm={7}>
            <Container>
              {title && (
                <Heading as="h1" size="sm">
                  {title}
                </Heading>
              )}
              {description && (
                <Text as="p" size="sm">
                  {description}
                </Text>
              )}
              {videoIframe}
              {contentComponent && content && <ContentComponent content={content} />}
            </Container>
          </Column>
        )}
      </Row>
    </Section>
  );
};

export default Video;
